{
  "id": "crosscutSled",
  "name": "Crosscut Sled",
  "builds": "tool",
  "category": "jigs",
  "note": "Build it square once, trust it forever.",
  "skill": "jigsAndFixtures",
  "duration": 40,
  "offeredBy": "bench",
  "fastener": "screws",
  "widthIn": 36,
  "heightIn": 36,
  "slots": [
    {
      "id": "base-0",
      "role": "base",
      "part": {
        "widthIn": 24,
        "lengthIn": 20,
        "thicknessQ": 3
      },
      "stock": {
        "type": "plywood",
        "sheetGrade": "jig",
        "thickness": "any"
      },
      "xIn": 18,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 1
    },
    {
      "id": "runner-0",
      "role": "runner",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 18,
      "yIn": 18,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "fence-0",
      "role": "fence",
      "part": {
        "widthIn": 4,
        "lengthIn": 36,
        "thicknessQ": 4
      },
      "stock": {
        "type": "board"
      },
      "xIn": 18,
      "yIn": 10,
      "angleDeg": 90,
      "zIn": 1.75
    }
  ],
  "fasteners": [
    {
      "xIn": 12,
      "yIn": 10
    },
    {
      "xIn": 24,
      "yIn": 10
    },
    {
      "xIn": 18,
      "yIn": 18
    }
  ]
}
